<template>
    <div class="odd-labels" v-if="ou">
        <div class="" v-for="odd in ou.odd">
            <Selection :selectedOdds="selectedOdds" :odd="odd" :match="match" :market="ou"></Selection>
        </div>
    </div>
</template>


<script>
    import betSlip from '@/mixins/betSlip'
    import Selection from "./selection";

    export default {
        name: 'winOdds',
        components: {Selection},
        mixins: [betSlip],
        props: {
            market: {
                type: Number,
                default: 1
            },
            onlyHeader: false,
            odds: {},
            match: {},
            selectedOdds: {}
        },
        data() {
            return {
                t: this.$root.t,
                ouDefault: {"id":"0","name":"","disabled":false,"closed":false,"hcp":"0:0","market":1,"markets":[1],"column":3,"layout":1,"order":3,"odd":{"1":{"id":14313037,"oddType":1,"outcome":"1","odd":"56.00","sp":"0.00","live":true,"active":false,"order":1,"change":"","r":"Waiting","resultId":1},"2":{"id":14313035,"oddType":1,"outcome":"X","odd":"5.80","sp":"0.00","live":true,"active":false,"order":2,"change":"","r":"Waiting","resultId":1},"3":{"id":14313034,"oddType":1,"outcome":"2","odd":"1.10","sp":"0.00","live":true,"active":false,"order":3,"change":"","r":"Waiting","resultId":1}}},
                ou: null,
                markets: [
                    1, 6, 201, 202, 2563, 377, -2527, 2563, 4476, 2434, 5488, 399, 6587, 6544, 8761, 8774, 8751, 8752, 8802, 9321, 9180, 8750, 8662
                ]
            }
        },
        watch: {
            odds: {
                handler() {
                   this.checkSpecialValue();
                },
                deep: true
            },
        },
        mounted() {
            this.ou = this.ouDefault;

            this.checkSpecialValue()
        },
        methods: {
            checkSpecialValue() {
                if (!this.odds)
                    return false;

                this.ou = this.ouDefault;
                Object.keys(this.odds).forEach((key) => {
                    if (this.markets.includes(this.odds[key].market)) {
                        this.ou = this.odds[key];
                    }
                });
            },
            fetchSelectedBets() {

            },
        }
    }
</script>

<style scoped>
    .odd-labels {
        display: flex;
        align-items: center;
        justify-content: space-between;
        min-width: 117px;
    }

    .odd-labels.pre {
        flex: 0 0 22%;
    }
</style>



// WEBPACK FOOTER //
// src/components/sportsbook/winOdds.vue